import List from './AccountantList'
import Registration from './AccountantRegistration'

const exportObj = {
    List,
    Registration
}

export default exportObj